export const OLD_SWATCH_LIST = [
    'fe42a6-a1.myshopify.com',
]